import { VIcon, VImg } from 'vuetify/components'
import type { VBtnProps } from '@/types/vuetify-components.ts'

export type IDeepBoxErrorBtn = VBtnProps
export type IDeepBoxErrorIcon = InstanceType<typeof VIcon>['$props']
export type IDeepBoxErrorImg = InstanceType<typeof VImg>['$props']

// codes for error states that get a dedicated, themed presentation in ContainerError.vue
export const DEEP_BOX_ERROR_CODES = {
  ELEVATED_AUTH_REQUIRED: 'elevated_auth_required',
} as const

export type DeepBoxErrorCode =
  (typeof DEEP_BOX_ERROR_CODES)[keyof typeof DEEP_BOX_ERROR_CODES]

export interface IDeepBoxError {
  message?: string
  name?: string
  title?: string
  description?: string
  img?: IDeepBoxErrorImg
  imgComponent?: Component
  icon?: IDeepBoxErrorIcon
  statusCode?: string | number
  hideStatusCode?: boolean
  deepBoxError?: boolean
  btn?: IDeepBoxErrorBtn
  errorCode?: DeepBoxErrorCode
}
